import React from "react";
import "./Process.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMagnifyingGlass,
  faPenNib,
  faCubes,
  faRocket,
  faChartLine,
  faCheckCircle,
  faBolt,
} from "@fortawesome/free-solid-svg-icons";

const Process = () => {
  const steps = [
    {
      step: "01",
      title: "Audit & Clarity",
      description:
        "We map what’s happening today: traffic → page → form → follow-up. Then we identify the highest-impact fixes.",
      icon: faMagnifyingGlass,
      bullets: ["Funnel review", "Tracking + speed scan", "Lead quality check"],
    },
    {
      step: "02",
      title: "Plan the Wins",
      description:
        "You get a simple blueprint: priorities, weekly milestones, and the exact pages/campaigns to build.",
      icon: faPenNib,
      bullets: ["KPIs + goals", "Messaging angles", "Channel priorities"],
    },
    {
      step: "03",
      title: "Build the Assets",
      description:
        "We create conversion-ready pages, creatives, and tracking events so everything is measurable from day one.",
      icon: faCubes,
      bullets: ["Landing pages", "Creatives + copy", "GA4 / Pixel events"],
    },
    {
      step: "04",
      title: "Launch & Test",
      description:
        "We go live with structured experiments. We test hooks, audiences, offers, and friction points fast.",
      icon: faRocket,
      bullets: ["A/B tests", "Budget splits", "Form + flow fixes"],
    },
    {
      step: "05",
      title: "Optimize & Scale",
      description:
        "We double down on winners, improve conversion rate, and scale confidently with clean reporting.",
      icon: faChartLine,
      bullets: ["CRO improvements", "Scale winners", "Weekly reporting"],
    },
  ];

  return (
    <section className="procX">
      <div className="procX__wrap">
        {/* Header */}
        <div className="procX__head">
          <span className="procX__badge">
            <FontAwesomeIcon icon={faBolt} /> Our process
          </span>
          <h2 className="procX__title">
            A clear system for <span>consistent</span> growth
          </h2>
          <p className="procX__sub">
            No random tasks. No chaos. Just a repeatable workflow that improves
            traffic quality, conversion rate, and follow-up.
          </p>
        </div>

        {/* Timeline grid */}
        <div className="procX__grid">
          {steps.map((s, idx) => (
            <article className="procX__card" key={idx}>
              <div className="procX__rail" aria-hidden="true">
                <span className="procX__dot" />
              </div>

              <div className="procX__top">
                <div className="procX__num">{s.step}</div>

                <div className="procX__ico">
                  <FontAwesomeIcon icon={s.icon} />
                </div>

                <div className="procX__meta">
                  <h3>{s.title}</h3>
                  <p>{s.description}</p>
                </div>
              </div>

              <div className="procX__points">
                {s.bullets.map((b, i) => (
                  <div className="procX__pt" key={i}>
                    <FontAwesomeIcon icon={faCheckCircle} />
                    <span>{b}</span>
                  </div>
                ))}
              </div>
            </article>
          ))}
        </div>

        {/* Bottom strip */}
        <div className="procX__strip">
          <div className="procX__stripLeft">
            <h4>What you get at the end</h4>
            <p>Roadmap • landing pages • creatives • tracking • optimization plan</p>
          </div>

          <div className="procX__stripRight">
            <span className="pill">Weekly sprints</span>
            <span className="pill">Clear deliverables</span>
            <span className="pill">Conversion-first</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;